// extracted by mini-css-extract-plugin
module.exports =  {"name":"qn1kDk841zbPM8lxEyJg","readonly":"kL8MQEnHwoSBCivR6Oqp","intelligent":"Re6uiPr2Edr0tjqEgOOt","tags":"zZo77oWDk1IxM_w1k7gs"};